module.exports = __webpack_public_path__ + "media/images/my_apps/ap_app icon_rounded_115-d865b28696a60378fe25786d961b9198.png";